import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

function SelectInput({
    loading,
    onChange,
    isMulti,
    options,
    defaultOptions,
    placeholder,
    noOptionsMessage,
    invertBackground,
    forcedValues,
    disabled,
    asCreatable,
    formatCreateLabel,
    validateCreatedOption,
    components,
    menuIsOpen,
    onlyCreate
}) {
    const [value, setValue] = useState(null);

    const selectOptions = options
        ? options.map(o => ({ ...o, value: o.name, label: o.name }))
        : [];

    const _onChange = (value, action) => {
        setValue(value);

        if (onChange) {
            onChange(value, action);
        }
    };

    // use validator from props to check for valid values, when adding new values
    const _onCreateOption = (createdOption, action) => {
        const isValid = validateCreatedOption(createdOption);
        if (isValid) {
            const newValue = [
                ...value,
                ...[{ name: createdOption, value: createdOption, label: createdOption }]
            ];

            setValue(newValue);

            if (onChange) {
                onChange(newValue, action);
            }
        }
    };

    const customStyles = {
        container: base => ({
            ...base,
            // zIndex: 2000
        }),
        control: base => ({
            ...base,
            ...(invertBackground ? { backgroundColor: '#F7F9FD' } : {})
        }),
        menu: base => ({
            ...base,
            ...(onlyCreate ? { display: 'none' } : {})
        }),
        menuList: base => ({
            ...base,
            ...(invertBackground ? { backgroundColor: '#F7F9FD' } : {})
        }),
        valueContainer: base => ({
            ...base,
            ...(invertBackground ? { backgroundColor: '#FFFFFF' } : {})
        })
    };

    /**
     * If defaultOptions given as prop, set to state as selected value
     */
    useEffect(() => {
        if (defaultOptions) {
            setValue(defaultOptions.map(d => ({ ...d, value: d.name, label: d.name })));
        }
    }, [defaultOptions]);

    /**
     * Forcefully re-render react-select by setting forced values
     */
    useEffect(() => {
        if (forcedValues && forcedValues.length) {
            setValue(forcedValues.map(v => ({ value: v, label: v })));
        }
    }, [forcedValues]);

    return (
        <>
            {!asCreatable
                ?
                    <Select
                        value={value}
                        onChange={_onChange}
                        isMulti={isMulti}
                        isDisabled={loading || disabled}
                        isLoading={loading}
                        options={selectOptions}
                        defaultValue={options ? options[1] : null}
                        placeholder={placeholder}
                        noOptionsMessage={() => <p>{noOptionsMessage}</p>}
                        styles={customStyles}
                    />
                :
                    <CreatableSelect
                        components={components}
                        value={value}
                        onChange={_onChange}
                        isMulti={isMulti}
                        isDisabled={loading || disabled}
                        isLoading={loading}
                        options={selectOptions}
                        menuIsOpen={menuIsOpen}
                        defaultValue={options ? options[1] : null}
                        placeholder={placeholder}
                        noOptionsMessage={() => <p>{noOptionsMessage}</p>}
                        formatCreateLabel={formatCreateLabel}
                        styles={customStyles}
                        onCreateOption={_onCreateOption}
                    />
            }
        </>
    );
}

export default SelectInput;